export default function HealthStatus({ loading, error }: { loading?: boolean | null; error: string | null }) {
	if (loading) {
		return (
			<div className="flex items-center justify-center h-16 ">
				<span className="text-zinc-600 dark:text-zinc-400">Loading...</span>
			</div>
		);
	}
	if (error) {
		return (
			<div className="flex items-center justify-center h-16 ">
				<span className="text-red-600 dark:text-red-500">Error: {error}</span>
			</div>
		);
	}
	return null;
}
